import React, { forwardRef, HTMLAttributes } from 'react';

import { PopupPlacement } from '../types';

export type PopupTailProps = HTMLAttributes<Element> & { placement?: PopupPlacement };

export const PopupTail = forwardRef<SVGSVGElement, PopupTailProps>(function PopupTail(props, ref) {
    if (props.placement?.startsWith('top') || props.placement?.startsWith('bottom')) {
        return (
            <svg
                width="40"
                height="10"
                viewBox="0 0 40 10"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
                ref={ref}
                {...props}
            >
                <path d="M0 10H5.02944C8.21203 10 11.2643 8.73572 13.5147 6.48528L18.5858 1.41421C19.3668 0.633163 20.6332 0.633165 21.4142 1.41421L26.4853 6.48529C28.7357 8.73572 31.788 10 34.9706 10H40H0Z" />
            </svg>
        );
    }

    return (
        <svg
            width="10"
            height="22"
            viewBox="0 0 10 22"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <path d="M10 18C10 17.3653 9.72265 16.7623 9.24074 16.3492L4.7716 12.5185C3.84038 11.7203 3.84038 10.2797 4.7716 9.48149L9.24074 5.65079C9.72265 5.23773 10 4.63471 10 4V18Z" />
        </svg>
    );
});
